module.exports = __webpack_public_path__ + "img/clock-icon.378613de.svg";